// const SERVER_URL = 'http://localhost:8000';
const SERVER_URL = 'https://datacollector.isl.iar.kit.edu/error_corrector';

const CORRECTOR = true; // process.env.REACT_APP_CORRECTOR == 'true'; reads environment variable REACT_APP_CORRECTOR

export { SERVER_URL, CORRECTOR };
